import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useResetPassword } from '../api/useAuth'
import { getErrMsg } from '../api/client'
import Input from '../components/ui/Input'
import toast from 'react-hot-toast'

export default function ResetPassword() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''
  const navigate = useNavigate()

  const [form, setForm] = useState({ password: '', confirm: '' })
  const [errors, setErrors] = useState({})

  const { mutate: resetPassword, isPending } = useResetPassword()

  const validate = () => {
    const e = {}
    if (form.password.length < 8) e.password = 'Минимум 8 символов'
    if (form.password !== form.confirm) e.confirm = 'Пароли не совпадают'
    return e
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const errs = validate()
    if (Object.keys(errs).length) { setErrors(errs); return }
    if (!token) { toast.error('Токен не найден'); return }
    setErrors({})
    resetPassword(
      { token, new_password: form.password },
      {
        onSuccess: () => {
          toast.success('Пароль успешно изменён!')
          navigate('/login')
        },
        onError: (err) => {
          toast.error(getErrMsg(err, 'Ошибка при сбросе пароля'))
        },
      }
    )
  }

  if (!token) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center px-4">
        <div className="text-center">
          <p className="text-lg mb-4 text-muted">
            Неверная или устаревшая ссылка
          </p>
          <Link to="/forgot-password" className="font-semibold transition-colors text-accent">
            Запросить новую ссылку
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div
        className="w-full max-w-sm rounded-2xl p-8 flex flex-col gap-6 bg-surface border border-line"
      >
        <div className="text-center">
          <h1 className="text-2xl font-black">Новый пароль</h1>
          <p className="text-sm mt-1 text-muted">
            Придумайте надёжный пароль
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Input
            label="Новый пароль"
            type="password"
            placeholder="Минимум 8 символов"
            value={form.password}
            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
            error={errors.password}
            autoComplete="new-password"
          />
          <Input
            label="Подтверждение пароля"
            type="password"
            placeholder="Повторите пароль"
            value={form.confirm}
            onChange={(e) => setForm((f) => ({ ...f, confirm: e.target.value }))}
            error={errors.confirm}
            autoComplete="new-password"
          />
          <button
            type="submit"
            disabled={isPending}
            className="w-full py-3 rounded-xl font-bold text-sm transition-all disabled:opacity-50 bg-accent text-on-accent hover:opacity-90"
          >
            {isPending ? 'Сохраняем...' : 'Сохранить пароль'}
          </button>
        </form>
      </div>
    </div>
  )
}
